const getDefaultState = () => {
  return {
    rematchRequestDoc: null,
    newPartner: null,

    firstRematch: false,
  };
};

const state = getDefaultState();

const getters = {};
// Synchronous
const mutations = {
  RESET(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },

  SET_REMATCH_REQUEST_DOC(state, doc) {
    state.rematchRequestDoc = doc;
  },

  SET_NEW_PARTNER(state, newPartner) {
    state.newPartner = newPartner;
  },

  SET_SUCCESSFUL_REMATCH_DATA(state, rematchedSession) {
    const partnerIndex = rematchedSession.partnerIndex;
    state.rematchRequestDoc = null;
    state.newPartner = rematchedSession.users[partnerIndex];
  },

  SET_FIRST_REMATCH_POPUP(state, newState) {
    state.firstRematch = newState;
  },
};

// Asynchronous
const actions = {
  reset({ commit }) {
    commit("RESET");
  },

  setRematchRequestDoc({ commit }, doc) {
    commit("SET_REMATCH_REQUEST_DOC", doc);
  },

  setNewPartner({ commit }, newPartner) {
    commit("SET_NEW_PARTNER", newPartner);
  },

  setSuccesfulRematchData({ commit }, rematchedSession) {
    commit("SET_SUCCESSFUL_REMATCH_DATA", rematchedSession);
  },

  setFirstRematchPopup({ commit }, newState) {
    commit("SET_FIRST_REMATCH_POPUP", newState);
  },
};

const rematching = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};

export default rematching;
